import { Outlet } from 'react-router-dom';

import { AuthGuard } from '../guards/AuthGuard';
import { CompanyProvider } from '../contexts/CompanyContext';

/**
 * The shell for screens meant for a ROOM, not an operator: no side nav, no top bar, no gutters.
 *
 * WHY IT IS NOT A DASHBOARD ROUTE. The studio board first lived under `/app` as a fixed overlay,
 * and the admin chrome painted straight over it — `DashboardLayout`'s `<main>` is
 * `position: fixed` with a `z-index`, which makes it a STACKING CONTEXT, so no z-index a child
 * picks can ever climb above the sidebar it is nested inside. Even solved, it would be the wrong
 * shape: the board is opened in a second tab and left up on a screen all day, while the trainer
 * keeps working in the first one — a page that shares the shell can't do that.
 *
 * What it keeps is everything that has to stay true off the dashboard: {@link AuthGuard}, so a
 * board URL is not a way around logging in, and {@link CompanyProvider}, because a board with no
 * company is a board with no logo and no brand colour — the whole point of showing it.
 */
const PresentationLayout = () => (
    <AuthGuard>
        <CompanyProvider>
            <Outlet />
        </CompanyProvider>
    </AuthGuard>
);

export default PresentationLayout;
